import {useDispatch, useSelector} from "react-redux"
import {changeEditorStatus, setTitlePlaceholderColorRed} from "../../actions"
import {STATUS_PUBLISH} from "../../constants/EditorStatus"
import React, {useState} from "react"
import {publishPost} from "../../actions/post"

export default function PublishButton() {
  const post = useSelector(state => state.post.newPost)
  const postType = Config.postType
  const canPublish = useSelector(state => state.post.uploadProgressCount === 0)
  const dispatch = useDispatch()

  const [publishing, setPublishing] = useState(false)

  function handlePublish() {
    if (!canPublish) {
      return;
    }

    if (post.title.trim().length === 0) {
      dispatch(setTitlePlaceholderColorRed(true));
      document.getElementsByClassName('textarea_tit')[0].focus();
      return;
    }

    if (postType !== 'template') {
      dispatch(changeEditorStatus(STATUS_PUBLISH))
    } else {
      dispatch(publishPost(
        post,
        postType,
        20,
        status => setPublishing(status),
        post.draftSequence
      ))
    }

  }

  return (
    <button type='button' className="btn btn-default" onClick={handlePublish} disabled={publishing}>
      {publishing? '저장 중' : '완료'}
    </button>
  )
}
